import React from "react";
import styles from '../../styles/educationFair.module.scss';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import CustomImage from "../CustomImage";
import LazyReveal from "../LazyReveal";
interface Props {
  eventData: any;
}

const StepUpSection: React.FC<Props> = ({ eventData }) => {

  return (
    <LazyReveal className={styles.ScholarshipStudent} style={{ background: eventData?.stepUpSection?.sectionBgColor || '#FBE7CC' }}>
      <Container>
        <Row>
          <div className={styles.heading}>
            <h2>{eventData?.stepUpSection?.sectionTitle}</h2>
          </div>
        </Row>
        <Row>
          <Col xl={6} lg={6} md={6} sm={12}>
            <div className='d-block d-sm-none mb-5'>
              <div className={styles.schStd}>
                <CustomImage src={eventData?.stepUpSection?.sectionImage} width={380} height={380} alt="scholarshipStud.png" className={styles.schStImg} />
              </div>
            </div>
            <div className={styles.SchContent}>
              {
                eventData?.stepUpSection?.offers?.length > 0 &&
                eventData?.stepUpSection?.offers.map((offer: string) => <p>{offer}</p>)
              }
            </div>
          </Col>
          <Col xl={6} lg={6} md={6} sm={12}>
            <div className={styles.schStd + " d-none d-sm-block"} >
              <CustomImage src={eventData?.stepUpSection?.sectionImage} width={380} height={380} alt="scholarshipStud.png" className={styles.schStImg} />
            </div>

          </Col>
        </Row>
      </Container>
    </LazyReveal>
  )
}

export default StepUpSection;
